<template>
  <div v-if="venta">
    <PrintTicketLayout :empleado="venta.empleado.text">
      <template v-slot:content>
        <div>
          <table style="border: 0; width: 100%">
            <tr>
              <td style="text-transform: uppercase; text-align: center"><strong>{{ $t("Factura simplificada") }}</strong></td>
            </tr>
          </table>

          <hr style="border: 1px dashed #000000; width: 100%; margin: 5px 0"/>

          <table style="border: 0; width: 100%">
            <tr>
              <td style="text-align: left">{{ configuracion_ticket.texto_num_factura_ticket }}</td>
              <td style="text-align: right;">{{ venta.num_ticket }}</td>
            </tr>
            <tr>
              <td style="text-align: left">{{ $t("Fecha de venta") }}</td>
              <td style="text-align: right;">{{ venta.created | moment('L') }} {{ venta.created | moment('HH:mm') }}</td>
            </tr>

            <tr>
              <td style="text-align: left; white-space: pre-line">{{ $t("Cliente") }}</td>
              <td style="text-align: right; white-space: pre-line" v-if="venta.cliente_venta">{{ venta.cliente_venta.nombre_completo}}</td>
            </tr>

            <tr>
              <td style="text-align: left">{{ $t("DNI") }}</td>
              <td style="text-align: right;" v-if="venta.cliente_venta">{{ venta.cliente_venta.dni}}</td>
            </tr>

            <tr>
              <td style="text-align: left">{{ $t("Dirección") }}</td>
              <td style="text-align: right; max-width: 120px" v-if="venta.cliente_venta">{{ venta.cliente_venta.direccion}}</td>
            </tr>

            <tr v-if="configuracion_marketing.is_programa_puntos && !venta.cliente_venta.is_anonymous">
              <td style="text-align: left">{{ $t("Puntos cliente:") }}</td>
              <td style="text-align: right;">
                {{ venta.cliente_venta.puntos }} = {{ venta.cliente_venta.puntos/configuracion_marketing.programa_puntos_puntos | money}}
              </td>
            </tr>
            <tr v-if="configuracion_marketing.programa_puntos_puntos_dias_caducidad > 0">
              <td style="text-align: left">{{ $t("Caducidad puntos:") }}</td>
              <td style="text-align: right;" v-if="configuracion_marketing">
                {{ $moment(venta.cliente_venta.fecha_ultima_venta).add(
                  configuracion_marketing.programa_puntos_puntos_dias_caducidad, 'days').format('DD/MM/YYYY') }}
              </td>
            </tr>
          </table>

          <hr style="border: 1px dashed #000000; width: 100%; margin: 5px 0"/>

          <table style="border: 0; width: 100%">
            <tbody>
            <tr>
              <td style="text-align: left; padding: 0;" class="font-weight-bold">{{ $t("Uds.") }}</td>
              <td style="text-align: center; padding: 0;" class="font-weight-bold">{{ $t("Prod.") }}</td>
              <td v-if="venta.lineas_venta.find(
                linea => linea.valor_descuento > 0
            )" style="text-align: center; padding: 0;" class="font-weight-bold">{{ $t("Desc.") }}
              </td>
              <td style="text-align: center; padding: 0 0 0 8px;" class="font-weight-bold">{{ $t("Importe") }}</td>
            </tr>
            <tr v-for="(currentlinea, index) in lineas_venta" :key="index">
              <td style="text-align: left; padding: 0;">{{ currentlinea.cantidad }}</td>
              <td style="text-align: center; padding: 0;">{{ currentlinea.descripcion }}
                <span v-if="currentlinea.bono && lista_bonos_vendidos &&
                lista_bonos_vendidos[currentlinea.bono_vendido] && lista_bonos_vendidos[currentlinea.bono_vendido].fecha_caducidad">
                  <br>{{ $t('Caducidad bono:') }} {{
                    lista_bonos_vendidos[currentlinea.bono_vendido].fecha_caducidad | moment('L')
                  }}
                </span>
                <span v-if="currentlinea.bono_vendido && !currentlinea.bono && $data.lista_bonos_vendidos" class="font-italic" style="font-size: 12px">
                <br>{{$t('Sesiones restantes: ')}}  {{currentlinea.servicio?findLimiteSesiones(
                    currentlinea.bono_vendido, currentlinea.servicio, 'servicio'):findLimiteSesiones(
                    currentlinea.bono_vendido, currentlinea.producto, 'producto')}}
              </span>
              </td>
              <td style="text-align: center; padding: 0;"
                  v-if="currentlinea.tipo_descuento ==='m' && currentlinea.valor_descuento > 0">
                {{ currentlinea.valor_descuento | money }}
              </td>
              <td style="text-align: center; padding: 0;"
                  v-else-if="currentlinea.valor_descuento > 0 && currentlinea.tipo_descuento !=='m'">
                {{ currentlinea.valor_descuento + '%' }}
              </td>
              <td v-else class="d-none"></td>
              <td style="text-align: center; padding: 0 0 0 8px;">{{ currentlinea.total | money }}</td>
            </tr>
            </tbody>
          </table>

          <hr style="border: 1px dashed #000000; width: 100%; margin: 5px 0"/>

          <table style="border: 0; width: 100%">
            <tbody>
            <tr>
              <td style="text-align: left; padding: 0;" class="font-weight-bold">{{ $t("Imp.") }}</td>
              <td style="text-align: center; padding: 0;" class="font-weight-bold">{{ $t("Base") }}</td>
              <td style="text-align: center; padding: 0;" class="font-weight-bold">{{ $t("Importe") }}</td>
              <td style="text-align: right; padding: 0;" class="font-weight-bold">{{ $t("Total") }}</td>
            </tr>
            <tr v-for="(currentlinea, index) in lineas_venta" :key="index">
              <td style="text-align: left; padding: 0;">{{ get_impuesto(currentlinea.impuesto) + '%' }}</td>
              <td style="text-align: center; padding: 0;">{{ get_base(currentlinea.total, currentlinea.impuesto) | money }}</td>
              <td style="text-align: center; padding: 0;">{{ currentlinea.total -  get_base(currentlinea.total, currentlinea.impuesto) | money }}</td>
              <td style="text-align: right; padding: 0;">{{ currentlinea.total | money }}</td>
            </tr>
            </tbody>
          </table>

          <hr style="border: 1px dashed #000000; width: 100%; margin: 5px 0"/>

          <table style="border: 0; width: 100%">
            <tbody>
            <tr v-if="venta.tarjeta_regalo_usada">
              <td style="text-align: left; padding: 0">{{ $t("Descuento tarjeta regalo:") }}</td>
              <td/>
              <td style="text-align: right; padding: 0">{{ venta.importe_tarjeta_regalo | money }}
              </td>
            </tr>
            <tr v-if="venta.tarjeta_regalo_usada">
              <td style="text-align: left; padding: 0">{{ $t("Saldo tarjeta regalo:") }}</td>
              <td/>
              <td style="text-align: right; padding: 0">{{ tarjeta_regalo.saldo_restante | money }}
              </td>
            </tr>

            <tr>
              <td style="text-align: left; padding: 0" v-if="venta.tarjeta_fidelidad_vendida">{{ $t("Descuento tarjeta fidelidad:") }}</td>
              <td/>
              <td style="text-align: right; padding: 0" v-if="venta.tarjeta_fidelidad_vendida">{{ venta.importe_tarjeta_fidelidad | money }}
              </td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 0" v-if="venta.tarjeta_fidelidad_vendida">{{ $t("Saldo tarjeta fidelidad:") }}</td>
              <td/>
              <td style="text-align: right; padding: 0" v-if="venta.tarjeta_fidelidad_vendida">{{ tarjeta_fidelidad.importe_restante | money }}
              </td>
            </tr>

            <tr v-if="venta.puntos_utilizados > 0">
              <td style="text-align: left; padding: 0">{{ $t("Puntos utilizados:") }}</td>
              <td/>
              <td style="text-align: right; padding: 0">{{ venta.puntos_utilizados }} = {{ venta.importe_programa_puntos | money }}
              </td>
            </tr>

            <tr v-if="venta.valor_descuento > 0">
              <td style="text-align: left; padding: 0">{{ $t("Descuento:") }}</td>
              <td/>
              <td style="text-align: right; padding: 0" v-if="venta.tipo_descuento === 'm'">{{ venta.valor_descuento | money }}</td>
              <td style="text-align: right; padding: 0" v-else>{{ venta.valor_descuento + '%'}}</td>
            </tr>

            <tr>
              <td style="text-align: left; padding: 0">{{ $t("Base imponible:") }}</td>
              <td/>
              <td style="text-align: right; padding: 0">{{ venta.base_imponible | money }}</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 0">{{ $t("Impuestos:") }}</td>
              <td/>
              <td style="text-align: right; padding: 0">{{ venta.importe_impuestos | money }}</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 0" class="font-weight-bold">{{ $t("Total:") }}</td>
              <td/>
              <td style="text-align: right; padding: 0" class="font-weight-bold">{{ venta.total | money }}
              </td>
            </tr>
            </tbody>
          </table>

          <hr style="border: 1px dashed #000000; width: 100%; margin: 5px 0"/>

          <table style="border: 0; width: 100%">
            <tbody>
            <tr>
              <td style="text-align: left; padding: 0">{{ $t("Forma de pago:") }}</td>

              <td style="text-align: right; padding: 0">{{ venta.forma_pago.text }}</td>
            </tr>
            <tr v-if="venta.forma_pago.value === 6"> <!-- 6 = Pago mixto -->
              <td style="text-align: left; padding: 0">
                {{ $t("Efectivo:") }}
              </td>
              <td style="text-align: right; padding: 0">{{ venta.entrega_efectivo | money }}</td>
            </tr>
            <tr v-if="venta.forma_pago.value === 6"> <!-- 6 = Pago mixto -->
              <td style="text-align: left; padding: 0">
                {{ $t("Tarjeta:") }}
              </td>
              <td style="text-align: right; padding: 0">{{ venta.entrega_tarjeta | money }}</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 0">{{ $t("Entregado:") }}</td>
              <td style="text-align: right; padding: 0">{{ venta.entrega | money }}</td>
            </tr>
            <tr v-if="venta.pendiente > 0">
              <td style="text-align: left; padding: 0 " class="font-weight-bold">{{ $t("Pendiente:") }}</td>
              <td style="text-align: right; padding: 0" class="font-weight-bold">{{ venta.pendiente | money }}</td>
            </tr>
            <tr v-if="venta.cambio">
              <td style="text-align: left; padding: 0">{{ $t("Cambio:") }}</td>
              <td style="text-align: right; padding: 0">
                {{ venta.cambio | money }}
              </td>
            </tr>
            </tbody>
          </table>
          
          <div v-if="configuracion_ticket.is_promocion_ticket && (venta.total >= configuracion_ticket.importe_minimo_promocion_ticket)">
            <hr style="border: 1px dashed #000000; width: 100%; margin: 5px 0"/>
  
  
            <table style="border: 0; width: 100%">
              <tbody>
              <tr>
                <td style="text-align: center; padding: 0">
                  {{ configuracion_ticket.texto_promocion_ticket }}
                </td>
              </tr>
              </tbody>
            </table>
          </div>

        </div>
      </template>
    </PrintTicketLayout>

    <!-- TICKETBAI -->
    <table v-if="venta.invoice_ticketbai" style="border: 0; width: 100%">
      <tbody>
        <tr>
          <td style="text-align: center;" height="10">
            <hr style="border: 1px dashed #000000; width: 100%; margin: 5px 0; display: inline-block"/>
          </td>
        </tr>
        <tr>
          <td style="text-align: center; font-size: 0.9em;">{{ venta.invoice_ticketbai.tbai_identifier }}</td>
        </tr>
        <tr>
          <td height="10"></td>
        </tr>
        <tr>
          <td style="text-align: center;">
            <img style="width: 50%;" :src="`data:image/png;base64, ${venta.invoice_ticketbai.batuz_qr_image}`" alt="">
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

import UserDeviceMixin from "@/mixins/UserDeviceMixin";

export default {
  name: 'PrintFacturaSimplificada',
  beforeDestroy() {
    document.title='Koibox'
  },
  mixins: [UserDeviceMixin],
  data: () => ({
    venta: null,
    lineas_venta: null,
    config_impuesto: null,
    configuracion_ticket: null,
    configuracion_marketing: null,
    tarjeta_regalo: null,
    tarjeta_fidelidad: null,
    lista_bonos_vendidos: {}
  }),

  methods: {
    /**
     * Cargamos la venta
     * @returns {Promise<void>}
     */
    async get_venta() {
      try {
        this.venta = await this.$store.dispatch('venta/get_venta', this.$route.params.id)

        // Cálculo de variables

        this.lineas_venta = this.venta.lineas_venta
        this.venta.pendiente = this.venta.total - this.venta.entrega
        this.venta.total_pendiente = this.venta.pendiente - this.venta.entrega

        if (this.venta.entrega > this.venta.total) {
          this.venta.cambio = this.venta.total - this.venta.entrega
        }

      } catch (err) {
        this.$snotify.error(
          this.$t("Ha ocurrido un error"),
          this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
      }
    },

    async get_bonos() {
      const lista_id_bonos = []
      this.venta.lineas_venta.forEach((current_linea)=>{
        if (current_linea.bono_vendido) {
          lista_id_bonos.push(current_linea.bono_vendido)
        }
      })

      if(!lista_id_bonos.length) return

      const result = await this.$store.dispatch('bono/get_sesiones_lista_bono_vendido', {params: {'id__in': lista_id_bonos.join(',')}})

      result.forEach((current_bono)=>{
        if (current_bono.limite_sesiones === null) {
          current_bono.sesiones_restantes_totales = null
        } else {
          current_bono.sesiones_restantes_totales = current_bono.limite_sesiones - current_bono.sesiones.reduce((total, sesion) => total += sesion.cantidad, 0)
        }
        this.$data.lista_bonos_vendidos[current_bono.id] = current_bono
      })

      this.lista_bonos_vendidos = {...this.lista_bonos_vendidos}
    },

    async get_datos_factura() {
      try {
        const common_impuesto = await this.$store.dispatch('impuesto/get_impuestos')

        this.config_impuesto = common_impuesto.results

      } catch (e) {
        this.$snotify.error(
          this.$t("Ha ocurrido un error"),
          this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
      }
    },

    /**
     * Obtenemos la confiugración de marketing del centro
     * @returns {Promise<void>}
     */
    async get_configuracion_marketing(){
      try{
        this.configuracion_marketing = await this.$store.dispatch('configuraciones/get', 'marketing')

      }catch (err){
        this.$snotify.error(
            this.$t("Ha ocurrido un error"),
            this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
      }
    },

    /**
     * Obtenermos la configuración de venta del centro
     * @returns {Promise<void>}
     */
    async get_configuracion_venta() {
      try {
        this.configuracion_ticket = await this.$store.dispatch('configuraciones/get', 'venta')
      } catch (err) {
        this.$snotify.error(
            this.$t("Ha ocurrido un error"),
            this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
      }
    },

    /**
     * Obtenermos las tarjetas de regalo y fidelidad usadas
     * @returns {Promise<void>}
     */
    async get_tarjetas() {
      try {
        // nota: el importe restante de las tarjetas es el actual, no el de cuando se hizo la venta
        if(this.venta.tarjeta_regalo_usada){
          const response = await this.$store.dispatch("tarjeta_regalo/get_tarjetas_regalo", {
            params: {'id__exact': this.venta.tarjeta_regalo_usada}
          });
          this.tarjeta_regalo = response.results[0]
        }
        if(this.venta.tarjeta_fidelidad_vendida){
          this.tarjeta_fidelidad = await this.$store.dispatch("tarjeta_fidelidad/get_tarjeta_fidelidad_vendida",
              this.venta.tarjeta_fidelidad_vendida)
        }
      } catch (err) {
        this.$snotify.error(
            this.$t("Ha ocurrido un error"),
            this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
      }
    },

    get_impuesto(impuesto_id) {
      let texto
      this.config_impuesto.forEach((impuesto)=>{
        if (impuesto.value === impuesto_id){
          texto = impuesto.text
        }
      })

      return texto
    },

    get_base(total, impuesto) {
      return total / ((this.get_impuesto(impuesto) + 100)/100)
    },

    findLimiteSesiones(id_bono, id_concepto, modo){
      if (modo === 'servicio') {
        for(let servicio of this.$data.lista_bonos_vendidos[id_bono].servicios) {
          if (servicio.servicio.id === id_concepto) {
            if (this.$data.lista_bonos_vendidos[id_bono].sesiones_restantes_totales === null) {
              return servicio.sesiones_restantes
            } else {
              return Math.min(this.$data.lista_bonos_vendidos[id_bono].sesiones_restantes_totales, servicio.sesiones_restantes)
            }
          }
        }
      } else {
        for(let producto of this.$data.lista_bonos_vendidos[id_bono].productos) {
          if (producto.producto.id === id_concepto) {
            if (this.$data.lista_bonos_vendidos[id_bono].sesiones_restantes_totales === null) {
              return producto.sesiones_restantes
            } else {
              return Math.min(this.$data.lista_bonos_vendidos[id_bono].sesiones_restantes_totales, producto.sesiones_restantes)
            }
          }
        }
      }
      return null
    },

    imprimir() {
      setTimeout(() => {
        if(this.centro.is_pass_print && (['mobile', 'tablet'].includes(this.get_device()))){
          let receiptHTML='<!DOCTYPE html><html><head><title></title><meta charset="UTF-8"><meta name="viewport" content="width=576"></head><body>';
          receiptHTML+=document.getElementById("content_ticket").innerHTML;
          receiptHTML+="</body></html>"
          const receiptB64=encodeURIComponent(receiptHTML);
          location.href = "starpassprnt://v1/print/nopreview?back=null&html=" + receiptB64
        }else{
          window.print()
        }
      }, 2000)
    }
  },

  async mounted() {
    await this.get_datos_factura()
    await this.get_configuracion_marketing()
    await this.get_configuracion_venta()
    await this.get_venta()
    await this.get_tarjetas()
    await this.get_bonos()
    if (this.venta.num_ticket) {
      document.title = 'Koibox_' + this.venta.num_ticket
    }
    this.imprimir()
  },

  components: {
    PrintTicketLayout: () => import('@/components/impresiones/PrintTicketLayout')
  }
}
</script>
